import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { InfoMenuModalComponent } from 'src/app/modals/info-menu-modal/info-menu-modal.component';
import { SelectTypePayModalComponent } from 'src/app/modals/select-type-pay-modal/select-type-pay-modal.component';
import { AuthService } from 'src/app/services/auth.service';
import { MenusService } from 'src/app/services/menus.service';
import { ShoppingService } from 'src/app/services/shopping.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-menu-page',
  templateUrl: './menu-page.component.html',
  styleUrls: ['./menu-page.component.scss'],
})
export class MenuPageComponent implements OnInit {
  menuId!: string;
  searchText!: any;

  products: any = [];
  productsAll = [];

  logoMenu: '' | undefined;

  loading: any = true;

  constructor(
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private menuService: MenusService,
    public shopping: ShoppingService,
    public modal: MatDialog,
    private router: Router,
    private authService: AuthService
  ) {}

  userLogin: any = false;

  async ngOnInit(): Promise<void> {
    this.loading = true;

    await this.authService.getLoginStatus().subscribe((status: boolean) => {
      this.userLogin = status;
    });

    this.route.params.subscribe((params: any) => {
      this.menuId = params.id;

      this.menuService.getMenu(this.menuId).subscribe((data: any) => {
        if (data.result) {
          this.shopping.addTicketUidMenu(this.menuId);
          let element = document.querySelector('.tittle-navbar') as HTMLElement;
          element.innerHTML = data.result.name;
          this.productsAll = data.result.products;

          this.logoMenu = data.result.logo;

          this.productsAll.forEach((product: any) => {
            product.search = product.name.toLowerCase();
          });
          this.products = this.productsAll;

          console.log(this.products);
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: data.message,
            showConfirmButton: false,
            timer: 1500,
          });
          history.back();
        }
        this.loading = false;
      });
    });
  }

  keyPress() {
    this.searchText = this.searchText.toLowerCase();
    this.products = this.productsAll.filter((product: any) => {
      return product.search.includes(this.searchText);
    });
  }

  clearSearchField() {
    this.searchText = '';
    this.products = this.productsAll;
  }

  openInfo() {
    const dialogRef = this.modal.open(InfoMenuModalComponent, {
      data: { idMenu: this.menuId },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe(async (result) => {
      if (result) {
      }
    });
  }

  disableButton() {
    const cart = this.shopping.getShoppingCart();

    const disableButton = !this.userLogin || cart.length == 0;
    return disableButton;
  }

  async openTypePay(): Promise<void> {
    const cart = this.shopping.getShoppingCart();
    if (this.userLogin && cart.length > 0) {
      const dialogRef = this.modal.open(SelectTypePayModalComponent, {
        data: {},
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe(async (result) => {});
    }
  }
}
